/**
 * Created by - Ashish on 08-07-2024
 * Reason - for storing global states
 */
import { useState, useEffect } from "react";
import { createContext } from "react";
import { useLocation } from "react-router-dom";
import { getSettingDetailsApi } from "../Api/services";
// import { refresh, userDetails } from "../Api/services";

export const GlobalContext = createContext();

export default function Context(props) {
  const location = useLocation();

  const [user, setUser] = useState({});
  const [settingDetail, setSettingDetail] = useState({});
  const [navigationPath, setNavigationPath] = useState([
    { name: "home", path: "/" },
  ]);
  useEffect(() => {
    fetchSettingData();
  }, []);

  const fetchSettingData = async () => {
    try {
      const response = await getSettingDetailsApi();
      setSettingDetail(response.setting_details);
    } catch (error) {
      console.error("Error fetching homepage details:", error);
    }
  };

  return (
    <>
      <GlobalContext.Provider
        value={{
          user,
          setUser,
          navigationPath,
          setNavigationPath,
          settingDetail,
          setSettingDetail,
        }}
      >
        {props.children}
      </GlobalContext.Provider>
    </>
  );
}
